var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNonVegIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.29166,
    y: 2.29169,
    width: 15.4167,
    height: 15.4167,
    rx: 2.70833,
    fill: "white",
    stroke: "#D90429",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61996 5.22917C9.78887 4.92361 10.2111 4.92361 10.38 5.22917L14.9406 13.4792C15.1095 13.7847 14.8983 14.1667 14.5605 14.1667H5.43949C5.10167 14.1667 4.89054 13.7847 5.05945 13.4792L9.61996 5.22917Z",
    fill: "#D90429"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonVegIcon);
export default __webpack_public_path__ + "static/media/nonVegIcon.3b980d7f7e916cb34429f9479e19fd15.svg";
export { ForwardRef as ReactComponent };